import { isValidFileType } from "utils/helpers";
import * as yup from "yup";

export const submitEvidenceStep2Schema = yup.object().shape({
  description: yup.string().required("Message is required").max(255, "Maximum 255 characters"),
  files: yup.mixed().test("is-valid-type", "Not a valid file type", (value) => isValidFileType(value)),
});
